export default __webpack_public_path__ + "static/media/AudioActive.a3f8a88d.svg";